<template>
  <div class="jifen-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="会员ID">
          <el-input v-model="filterForm.crm_id" placeholder="请输入会员ID" clearable style="width: 140px;" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="filterForm.type" placeholder="全部" clearable style="width: 130px;">
            <el-option label="获得" :value="1" />
            <el-option label="消耗" :value="2" />
            <el-option label="人工增加" :value="3" />
            <el-option label="人工减少" :value="4" />
            <el-option label="退回" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="来源">
          <el-select v-model="filterForm.source" placeholder="全部" clearable style="width: 150px;">
            <el-option label="注册" value="register" />
            <el-option label="分享获客" value="referral" />
            <el-option label="下单" value="consume" />
            <el-option label="邀请消费" value="referral_consume" />
            <el-option label="兑换" value="exchange" />
            <el-option label="人工" value="manual" />
            <el-option label="退回" value="refund" />
          </el-select>
        </el-form-item>
        <el-form-item label="变动时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="flowList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="流水ID" width="90" align="center" />
        <el-table-column prop="mem_user" label="会员" width="100" align="center" />
        <el-table-column prop="sh_id" label="来源店铺" width="90" align="center" />
        <el-table-column prop="type_name" label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="typeTagType(scope.row.type)">{{ scope.row.type_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ sourceText(scope.row.source) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="变动积分" width="120" align="center">
          <template slot-scope="scope">
            <span :class="parseInt(scope.row.points) >= 0 ? 'points-in' : 'points-out'">
              {{ parseInt(scope.row.points) >= 0 ? '+' : '' }}{{ scope.row.points }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="balance_after" label="变动后余额" width="120" align="center" />
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column prop="operator" label="操作人" width="90" align="center" />
        <el-table-column prop="comlist3" label="变动时间" width="160" />
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>
  </div>
</template>

<script>
import { flowLists } from '@/api/jifen'

export default {
  name: 'JifenFlows',
  data () {
    return {
      loading: false,
      flowList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        crm_id: '',
        type: '',
        source: ''
      },
      dateRange: []
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    typeTagType (type) {
      const map = { 1: 'success', 2: 'danger', 3: 'primary', 4: 'warning', 5: 'info' }
      return map[parseInt(type)] || 'info'
    },

    sourceText (source) {
      const map = {
        register: '注册',
        referral: '分享获客',
        consume: '下单',
        referral_consume: '邀请消费',
        exchange: '兑换',
        manual: '人工',
        refund: '退回'
      }
      return map[source] || source || '—'
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.crm_id) params.crm_id = this.filterForm.crm_id
        if (this.filterForm.type !== '' && this.filterForm.type !== null) params.type = this.filterForm.type
        if (this.filterForm.source) params.source = this.filterForm.source
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date = this.dateRange[1]
        }
        const res = await flowLists(params)
        if (res && res.code === '0') {
          this.flowList = res.data || []
          this.total = res.total || 0
        } else {
          this.flowList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取积分流水失败')
        }
      } catch (error) {
        console.error('获取积分流水失败', error)
        this.flowList = []
        this.total = 0
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { crm_id: '', type: '', source: '' }
      this.dateRange = []
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    }
  }
}
</script>

<style lang="scss" scoped>
.jifen-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .points-in {
    color: #67c23a;
    font-weight: bold;
  }

  .points-out {
    color: #f56c6c;
    font-weight: bold;
  }
}
</style>
